import Vue from "vue";
import Axios from "axios";
import Qs from "qs";
import setting from "@/setting";
import router from "../../router";


var jwtHeader = window.AbJwtSetting.getHeader();
var headers = {};
if (jwtHeader) {
  headers[window.AbJwtSetting.headerName] = jwtHeader;
}
var axios = Axios.create({
  baseURL: setting.apiBaseURL,
  timeout: "60000", //请求超时时间
  //header传值，例如：Authorization
  headers: headers,
});
axios.defaults.withCredentials = true;

const pendingRequest = new Map();

function generateReqKey(config) {
  const { method, url, params, data } = config;
  return [method, url, Qs.stringify(params), Qs.stringify(data)].join("&");
}

function addPendingRequest(config) {
  const requestKey = generateReqKey(config);
  config.cancelToken =
    config.cancelToken ||
    new Axios.CancelToken((cancel) => {
      if (!pendingRequest.has(requestKey)) {
        pendingRequest.set(requestKey, cancel);
      }
    });
}

function removePendingRequest(config) {
  const requestKey = generateReqKey(config);
  if (pendingRequest.has(requestKey)) {
    const cancel = pendingRequest.get(requestKey);
    cancel(requestKey);
    pendingRequest.delete(requestKey);
  }
}

axios.interceptors.request.use(function (request) {
  request.credentials = true;
  return request;
});

// axios.interceptors.request.use(
// 	function (config) {
// 	  removePendingRequest(config); // 检查是否存在重复请求，若存在则取消已发的请求
// 	  addPendingRequest(config); // 把当前请求添加到pendingRequest对象中
// 	  return config;
// 	},
// 	(error) => {
// 	  return Promise.reject(error);
// 	}
// );

// 设置通用的拦截器
axios.interceptors.response.use(
  function (response) {
    
    removePendingRequest(response.config); // 从pendingRequest对象中移除请求
    if (response.data.code == "401") {
      router.push({ path: "/login" });
      return response;
    }
    if (response.data && !response.data.isOk && response.data.code === "403") {
      console.info(response);
      Vue.prototype.$Message.error("访问受限！");
      return response;
    }
    return response;
  },
  function (error) {
    removePendingRequest(error.config || {}); // 从pendingRequest对象中移除请求
    //通用异常
    return Promise.reject(error);
  }
);

// Http Util 基础服务
var HttpUtil = {
  get: function (url) {
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          console.log("请求失败：", error);
          reject(error);
        });
    });
  },
  post: function (url, data) {
    if (!data) data = {};

    return new Promise((resolve, reject) => {
      axios
        .post(url, data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          console.log("请求失败：", error);
          reject(error);
        });
    });
  },
  // form-data格式化
  postForm: function (url, data) {
    if (!data) data = {};
    return new Promise((resolve, reject) => {
      axios
        .post(url, data, {
          transformRequest: this.jsonToFormData,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
          },
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          console.log("请求失败：", error);
          reject(error);
        });
    });
  },
  postFile: function (url, data) {
    if (!data) data = {};
    return new Promise((resolve, reject) => {
      axios
        .post(url, data, {
          headers: { "Content-Type": "application/x-www-form-urlencoded; " },
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          console.log("请求失败：", error);
          reject(error);
        });
    });
  },

  jsonToFormData: function (data) {
    data = Qs.stringify(data, { arrayFormat: "brackets" }); // qs.stringify(params)
    return data;
  },
};

export default {
  // 全局安装时候
  install(Vue) {
    Vue.abHttpUtil = HttpUtil;
    Vue.prototype.abHttpUtil = HttpUtil;
    Vue.prototype.abAxios = axios;
  },
};
